export const emptyCheck = {
  extrinsic: {},
  payload: {}
};